export default {
    profile: '/contact-details',
};
